import { Outlet } from 'react-router-dom';
import { AppSidebar } from './AppSidebar';

export function AppAdminLayout() {
  return (
    <div className="flex h-screen overflow-hidden bg-gray-50">
      <AppSidebar isAdmin={true} />
      <main className="flex-1 overflow-auto">
        <Outlet />
      </main>
    </div>
  );
}